import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {CommonService, UserService} from '../../../../services';
import {ReportProvider} from '../../../../providers';

@Component({
  selector: 'app-transfer-report-modal',
  templateUrl: './transfer-report-modal.component.html',
  styleUrls: ['./transfer-report-modal.component.scss']
})
export class TransferReportModalComponent implements OnInit {

  subject: Subject<boolean>;
  reportId: string = '';
  NEW_EMAIL: string = null;

  error: string = '';
  errorEmail: string = '';

  constructor(public bsModalRef: BsModalRef,
              public userService: UserService,
              private reportProvider: ReportProvider,
              public commonService: CommonService) { }

  ngOnInit(): void {
  }

  /**
   * @description update prepared entity fields
   */
  callUpdateGroupAPI() {
    this.error = '';
    this.reportProvider.transferReport(this.reportId, this.NEW_EMAIL).subscribe(res => {
      if (res.success) {
        this.confirm();
      } else {
        this.error = res.error.txt;
        this.errorEmail = this.NEW_EMAIL;
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description Remove error message
   */
  removeErrorMsg(): void{
    if(this.error && this.errorEmail !== this.NEW_EMAIL){
      this.error = '';
    }
  }

  /**
   * @description confirm click
   */
  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }

  /**
   * @description cancel click
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
